import { BasicButton, BasicInput, ModalComponent, OptionSelect, SelectComponent } from "Common/Components";
import { useModalEmploye } from "../../hooks";

export const ModalEmploye = () => {
  const { isEdit, isOpenModal, clearAll, formik, setIsOpenModal, branch, t, valueBranch, usertype, valueUsertype, role, valueRole } =
    useModalEmploye();

  return (
    <ModalComponent
      modalTitle={
        isEdit ? t("createEmploye.FormEmploye.edithEmploye") : t("createEmploye.FormEmploye.createEmploye")
      }
      show={isOpenModal}
      onHide={() => {
        setIsOpenModal(false);
        clearAll();
        formik.resetForm();
      }}
      size="xl"
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className="col-span-6">
            <BasicInput
              label={t("createEmploye.FormEmploye.name")}
              placeholder={t("createEmploye.FormEmploye.inputNamePlaceholder")}
              id="names"
              type="text"
              value={formik.values.names}
              isError={
                !!(formik.touched.names && formik.errors.names)
              }
              errorMessage={formik.errors.names || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>

          <div className="col-span-6">
            <BasicInput
              label={t("createEmploye.FormEmploye.surnames")}
              placeholder={t("createEmploye.FormEmploye.inputSurnamePlaceholder")}
              id="surnames"
              type="text"
              value={formik.values.surnames}
              isError={!!(formik.touched.surnames && formik.errors.surnames)}
              errorMessage={formik.errors.surnames || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>

          <div className="col-span-6">
            <BasicInput
              label={t("createEmploye.FormEmploye.address")}
              placeholder={t("createEmploye.FormEmploye.inputAddressPlaceholder")}
              id="address"
              type="text"
              value={formik.values.address}
              isError={!!(formik.touched.address && formik.errors.address)}
              errorMessage={formik.errors.address || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>

          <div className="col-span-6">
            <BasicInput
              label={t("createEmploye.FormEmploye.phonenumber")}
              placeholder={t("createEmploye.FormEmploye.inputPhonePlaceholder")}
              id="phonenumber"
              type="text"
              value={formik.values.phonenumber}
              isError={
                !!(formik.touched.phonenumber && formik.errors.phonenumber)
              }
              errorMessage={formik.errors.phonenumber || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="col-span-6">
            <BasicInput
              label={t("createEmploye.FormEmploye.email")}
              placeholder={t("createEmploye.FormEmploye.inputemailPlaceholder")}
              id="email"
              type="text"
              value={formik.values.email}
              isError={
                !!(formik.touched.email && formik.errors.email)
              }
              errorMessage={formik.errors.email || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>


          <div className="col-span-6">
            <SelectComponent
              label={t("createEmploye.FormEmploye.branch")}
              placeholder={t("createEmploye.FormEmploye.branchPlaceholder")}
              options={branch || []}
              id="branch_id"
              isMulti={false}
              onBlur={formik.handleBlur}
              value={valueBranch}
              onChange={(option: OptionSelect) => {
                formik.setFieldValue("branch_id", option.value);
              }}

              isError={
                !!(
                  formik.touched.branch_id && formik.errors.branch_id
                )
              }
              errorMessage={formik.errors.branch_id || ""}
            />
          </div>
          <div className="col-span-6">
            <SelectComponent
              label={t("createEmploye.FormEmploye.usertype")}
              placeholder={t("createEmploye.FormEmploye.usertypePlaceholder")}
              options={usertype || []}
              id="user_type"
              isMulti={false}
              onBlur={formik.handleBlur}
              value={valueUsertype}
              onChange={(option: OptionSelect) => {
                formik.setFieldValue("user_type", option.value);
              }}

              isError={
                !!(
                  formik.touched.user_type && formik.errors.user_type
                )
              }
              errorMessage={formik.errors.user_type || ""}
            />
          </div>
          <div className="col-span-6">
            <SelectComponent
              label={t("createEmploye.FormEmploye.role")}
              placeholder={t("createEmploye.FormEmploye.rolePlaceholder")}
              options={role || []}
              id="role_id"
              isMulti={false}
              onBlur={formik.handleBlur}
              value={valueRole}
              onChange={(option: OptionSelect) => {
                formik.setFieldValue("role_id", option.value);
              }}

              isError={
                !!(
                  formik.touched.role_id && formik.errors.role_id
                )
              }
              errorMessage={formik.errors.role_id || ""}
            />
          </div>
          <div className="col-span-12">
            <div className="flex justify-end">
              <BasicButton
                onClick={formik.handleSubmit}
                disabled={formik.isSubmitting}
                type="submit"
              >
                <span className="text-white">
                  {isEdit
                    ? t("createEmploye.SaveBtn")
                    : t("createEmploye.SaveBtn")}
                </span>
              </BasicButton>
            </div>
          </div>
        </div>
      </form>
    </ModalComponent>
  );
};
